const UPDATE_PAGE = 'edit-page/UPDATE_PAGE';

export default {
  UPDATE_PAGE,
};



// WEBPACK FOOTER //
// ./src/app/edit-page/store/mutation-types.js